//filters

export const FILTER_PERIOD = 'period';
export const GA_FILTER_PERIOD = 'periodRange';
export const FILTER_MANAGERS = 'managers';
export const FILTER_USERS = 'users';
export const FILTER_PAGE = 'page';
export const FILTER_TYPE = 'type';

export const COLUMN_TIME = 'time';
export const COLUMN_USER = 'user';
export const COLUMN_PAGE = 'page';
export const COLUMN_TYPE = 'type';
export const COLUMN_DETAILS = 'details';
